
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { submitToZoho } from "@/utils/secureFormSubmission";

const EmailSubscriptionBanner = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    try {
      const success = await submitToZoho({
        firstName: '',
        lastName: '',
        email: email,
        company: '',
        message: 'Email subscription for threat alerts and cyber intelligence',
        formType: 'Email Subscription'
      });

      if (success) {
        toast.success("Thank you for subscribing! We'll keep you updated with exclusive threat alerts and cyber intelligence.");
        setEmail("");
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      toast.error("Subscription failed. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section 
      className="py-12 md:py-16 relative overflow-hidden"
      style={{
        backgroundImage: 'url(/lovable-uploads/58957d2d-8978-4947-a034-03d9d505c800.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Enhanced dark overlay with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900/80 via-black/70 to-slate-800/80"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#8932c8]/20 via-transparent to-[#8932c8]/10"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6">
            Get Exclusive Threat Alerts, Event Invites, and the Latest in 
            <span className="text-[#8932c8]"> Cyber Intelligence</span> Delivered to Your Inbox
          </h2>
          
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <Input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                required
                className="flex-1 bg-white/10 border-white/20 text-white placeholder:text-gray-300 focus:bg-white/20 focus:border-[#8932c8] h-12"
              />
              <Button 
                type="submit"
                disabled={isSubmitting}
                className="bg-[#8932c8] hover:bg-[#7a2cb3] text-white px-6 md:px-8 py-3 h-12 whitespace-nowrap font-medium"
              >
                {isSubmitting ? "Subscribing..." : "Subscribe"}
              </Button>
            </div>
            <p className="text-xs md:text-sm text-gray-400 mt-3 md:mt-4">
              By submitting this form, you agree to our Terms of Use and acknowledge our privacy policy.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EmailSubscriptionBanner;
